import React from 'react';
export function IntroSection() {
  return <section className="py-16 md:py-24 bg-brand-black" data-id="element-759">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-760">
        <div className="prose prose-invert prose-lg max-w-none text-brand-gray-300 leading-relaxed space-y-6" data-id="element-761">
          <p data-id="element-762">
            <strong className="text-brand-white" data-id="element-763">Jose Medina</strong> brings
            over 2 decades of experience in developing and delivering
            high-quality training programs for law enforcement and dispatcher
            communities. Recognizing the lack of reality-based training for
            first responders in 2002, he was inspired to embark on a mission to
            enhance the skills and mindset of police officers and dispatchers
            nationwide.
          </p>
          <p data-id="element-764">
            Throughout his career, Jose Medina has been invited by respected
            organizations such as LEAD, the Association of SWAT Personnel, and
            other tactical organizations to provide expert training and guest
            speaker sessions at annual conferences. Jose Medina has given
            analyst commentary on all major media outlets discussing critical
            incident events involving active shooter mass casualty events. His
            programs focus on practical tactical applications and response
            strategies, empowering officers to carry out their daily duties with
            increased confidence and effectiveness.
          </p>
          <p data-id="element-765">
            For over two decades, Jose Medina and Medina Tactical Dynamics-Team
            APC have collaborated with top-tier police agencies, delivering
            tailored training solutions that address the unique needs of each
            agency.
          </p>
          <div className="p-6 border-l-4 border-brand-teal bg-brand-gray-900/50 mt-8" data-id="element-766">
            <p className="text-brand-white font-medium m-0" data-id="element-767">
              For more information about our exclusive training and services,
              please contact us at:{' '}
              <a href="mailto:Info@apc360zone.com" className="text-brand-teal hover:text-brand-teal-light transition-colors" data-id="element-768">
                Info@apc360zone.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>;
}